// extracted by mini-css-extract-plugin
module.exports = {"opHoursSopValue":"OperatingHoursSopValue_opHoursSopValue__2061H","timetableLink":"OperatingHoursSopValue_timetableLink__bhlIO"};